export default __webpack_public_path__ + "assets/fonts/Roboto-Bold.ttf";